(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('joinTeam', joinTeam);

    /* @ngInject */
    function joinTeam($sce) {
        var directive = {
            bindToController: true,
            templateUrl: 'join-team.tpl',
            controller: joinTeamController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs, sce) {
            scope.vm.teamId = null;
            scope.vm.message = '';
            scope.vm.messageActive = false;
            if (scope.vm.data.capitan_message) {
                scope.vm.data.capitan_message = $sce.trustAsHtml(scope.vm.data.capitan_message);
            }
        }
    }

    /* @ngInject */
    function joinTeamController($scope, $rootScope, $http, $sce) {
        $scope.request = function(method, data, callback) {
            if (!$scope.requesting) {
                $scope.requesting = true;
                $http.post(ajaxurl, {
                    action: 'pie_action',
                    method: method,
                    nonce: $scope.$root.stats.nonce,
                    params: data
                }).then(function(response) {
                    $scope.requesting = false;
                    if (response.data.message) {
                        $scope.vm.message = $sce.trustAsHtml(response.data.message);
                        $scope.vm.messageActive = true;
                        setTimeout(function() {
                            $scope.$apply(function() {
                                $scope.vm.message = "";
                                $scope.vm.messageActive = false;
                            });
                        }, 10000);
                    }
                    if (response.data.result) {
                        if (typeof callback == 'function') {
                            callback(response.data.payload || {});
                        }
                    }
                });
            }
        };

        $scope.leaveTeam = function() {
            $scope.request('leave_team', {}, function(payload) {
                $scope.vm.data.team = payload.team || "";
                $scope.vm.data.capitan_message = payload.capitan_message || "";
                $scope.vm.data.is_capitan = payload.is_capitan || false;
                $scope.vm.data.teams = payload.teams;
                $scope.vm.teamId = null;
            });
        };

        $scope.joinTeam = function() {
            $scope.request('join_team', {term_id : $scope.vm.teamId}, function(payload) {
                $scope.vm.data.team = payload.team;
            });
        };
    }

})();